<template>
	<v-btn
		:color="!deleteButton ? 'blue' : 'red'"
		dark
		round
		@click="$emit('click')"
		:disabled="disabled"
	>
		<v-icon dark >{{icon}}</v-icon>
		{{text}}
	</v-btn>
</template>

<script>
	export default {
		name: "OfferButton",

		props: {
			deleteButton: Boolean,
			text: String,
			icon: String,
			disabled: {default: false}
		},

	};
</script>

<style scoped>

</style>
